import { Store } from 'vuex';
import { RootState } from '@/ui/store/types/root-module.types';
import { ObjectLike } from '@/types/objectlike.types';
import { iProfile } from '@/entities/profile/profile.types';
import { PROFILE_MUTATIONS } from '@/ui/store/modules/profile/mutations';

export default function useProfileFunctions(
  $store: Store<RootState>,
  profileVariables: ObjectLike,
) {
  async function loadUser(userIdOrSlug: string) {
    $store.dispatch('profile/clear');

    const { loading, idOrSlug } = profileVariables;

    idOrSlug.value = userIdOrSlug;
    loading.value = true;

    await $store.dispatch('profile/loadUser', userIdOrSlug);

    loading.value = false;
  }

  async function loadReviews() {
    const { loading, showWelcome } = profileVariables;

    const user: iProfile = $store.getters['profile/profile'];

    if (!user) {
      // TODO redirect to home if no profile is found
      return;
    }

    loading.value = true;
    await $store.dispatch('profile/loadReviews', user.id);

    loading.value = false;
    const reviews = $store.getters['profile/reviews'];

    if (!reviews.length) {
      showWelcome.value = true;
    }
  }

  async function loadMoreReviews(entries: ObjectLike[]) {
    const { loading } = profileVariables;
    const [entry] = entries;

    const user: iProfile = $store.getters['profile/profile'];

    if (!user) {
      // TODO redirect to home if no profile is found
      return;
    }

    if (!loading.value && entry.isIntersecting) {
      loading.value = true;
      await $store.dispatch('profile/loadMore', user.id);
      loading.value = false;
    }
  }

  function watchAndLoad() {
    $store.subscribe(
      (mutation) => {
        if (mutation.type === `profile/${PROFILE_MUTATIONS.SET_PROFILE}`) {
          loadReviews();
        }
      },
    );
  }

  return {
    loadReviews,
    loadMoreReviews,
    loadUser,
    watchAndLoad,
  };
}
